import api from '@/services/api';

export default async function downloadFromUrl({ path, name }) {
  const response = await api().get(path, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;

  const nameWithExtension = name.includes('.pdf') ? name : `${name}.pdf`;
  link.setAttribute('download', nameWithExtension);

  const app = document.getElementById('app');
  app.appendChild(link);
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(link);
    link.remove();
  }, 1500);
}
